import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { ReactiveFormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzResultModule } from 'ng-zorro-antd/result';
import { RouterModule } from '@angular/router';
import { ConfirmationMailComponent } from './confirmation-mail.component';

@NgModule({
  declarations: [ConfirmationMailComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzCardModule,
    NzButtonModule,
    NzLayoutModule,
    NzGridModule,
    NzSkeletonModule,
    NzFormModule,
    NzInputModule,
    NzIconModule,
    NzResultModule,
    RouterModule
  ],
  exports: [ConfirmationMailComponent]
})
export class ConfirmationMailModule {}
